import { adminCall } from '../../api/adminCall';

export async function processAdminDeluxePayment(params) {
  const {
    amount,
    cryptogram,
    currency = 'USD',
    performedByUid,
    performedByEmail,
    customerName,
    customerEmail,
    description,
  } = params;
  if (!amount || !cryptogram) {
    throw new Error('Missing required payment details');
  }

  const responseData = await adminCall('/api/admin/payments/deluxe', {
    amount: String(amount),
    cryptogram,
    currency,
    customer: {
      name: customerName || null,
      email: customerEmail || null,
    },
    description: description || null,
    performedBy: {
      uid: performedByUid || null,
      email: performedByEmail || null,
    },
  });
  if (!responseData?.success) {
    throw new Error(responseData?.message || 'Deluxe payment failed');
  }
  return responseData;
}
